import type { ComponentType } from "react";

/** Was ein Symbol-Prop annimmt: Lucide-Icons und die Briefgeist-Glyph (gleiche Props). */
export type IconProps = { size?: number | string; strokeWidth?: number | string; className?: string; "aria-hidden"?: boolean | "true" | "false" };
export type IconTyp = ComponentType<IconProps>;

/** Briefgeist-Glyph (D-060, W22a): steht fuer die KI und ersetzt das Funkel-Icon (Lucide `sparkles`).
 *  Inline-SVG aus marke/briefgeist-glyph.svg (gefuellt) bzw. briefgeist-glyph-linie.svg, einfarbig
 *  ueber currentColor; Klasse `briefgeist` (Abnahme-Regel 13 laesst `svg.lucide, svg.briefgeist` zu).
 *  `aktiv`: die KI antwortet gerade, dann wird nur der Funke Postgelb (--pg-ai-fill, bausteine.css);
 *  sonst bleibt alles in currentColor. Nie als Dekoration (kein Leerzustand, kein Wasserzeichen). */
export function Briefgeist(props: IconProps & { aktiv?: boolean; linie?: boolean }) {
  const groesse = props.size ?? 20;
  const klasse = `briefgeist ${props.className ?? ""}`.trim();
  const ki = props.aktiv ? "antwortet" : undefined;
  if (props.linie) {
    return (
      <svg
        viewBox="0 0 64 64"
        width={groesse}
        height={groesse}
        fill="none"
        stroke="currentColor"
        strokeWidth={4.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
        className={klasse}
        data-ki={ki}
      >
        <path d="M11 31A20 20 0 0 1 51 31V50a3.333 3.333 0 0 1-6.667 0a3.333 3.333 0 0 1-6.667 0a3.333 3.333 0 0 1-6.667 0a3.333 3.333 0 0 1-6.667 0a3.333 3.333 0 0 1-6.667 0a3.333 3.333 0 0 1-6.667 0Z" />
        <path d="M15 34.5L31 45L47 34.5" />
        <circle cx="24" cy="25.5" r="2.2" fill="currentColor" stroke="none" />
        <circle cx="38" cy="25.5" r="2.2" fill="currentColor" stroke="none" />
        <path className="funke" d="M54 4Q54 12 62 12Q54 12 54 20Q54 12 46 12Q54 12 54 4Z" fill="currentColor" stroke="none" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 64 64" width={groesse} height={groesse} fill="currentColor" aria-hidden="true" focusable="false" className={klasse} data-ki={ki}>
      <path
        fillRule="evenodd"
        d="M11 31A20 20 0 0 1 51 31V50a3.333 3.333 0 0 1-6.667 0a3.333 3.333 0 0 1-6.667 0a3.333 3.333 0 0 1-6.667 0a3.333 3.333 0 0 1-6.667 0a3.333 3.333 0 0 1-6.667 0a3.333 3.333 0 0 1-6.667 0Z M27.6 25.5a3.6 3.6 0 1 0-7.2 0a3.6 3.6 0 1 0 7.2 0Z M41.6 25.5a3.6 3.6 0 1 0-7.2 0a3.6 3.6 0 1 0 7.2 0Z M14 33.2L31 44.4L48 33.2L48 38L31 49.2L14 38Z"
      />
      <path className="funke" d="M54 4Q54 12 62 12Q54 12 54 20Q54 12 46 12Q54 12 54 4Z" />
    </svg>
  );
}

/** Glyph im Zustand „KI antwortet“ (Funke gelb), als Symbol-Prop fuer Knoepfe, waehrend eine KI-Anfrage
 *  laeuft. */
export function BriefgeistAktiv(props: IconProps) {
  return <Briefgeist {...props} aktiv />;
}
